import { Helmet } from "react-helmet-async";

const SITE = "https://www.b7search.com";

export default function Seo({ title, description, path = "/", image }) {
  const fullTitle = title ? `${title} — B7 Search & Selection` : "B7 Search & Selection — Construction Recruitment";
  const desc = description ||
    "Specialist construction & engineering recruitment placing candidates across the UK, Europe and the Middle East.";
  const url = `${SITE}${path}`;
  const og = image || `${SITE}/brand/b7-logo.jpg`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={og} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={og} />
    </Helmet>
  );
}
